import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { IHtmonSlice } from './types';

const initialState: IHtmonSlice = {
  properties: null,
};

const htmonSlice = createAppSlice({
  name: 'htmon',
  initialState,
  reducers: {
    setRegisteredProperties(
      state,
      action: PayloadAction<IHtmonSlice['properties']>,
    ) {
      state.properties = action.payload;
    },
  },
});

export const { setRegisteredProperties } = htmonSlice.actions;
export default htmonSlice.reducer;
